import { cn } from "@/utils/utils";
import React from "react";

interface CardInfoProps {
  children: React.ReactNode;
  className?: string;
  gradientBorder?: boolean;
  borderGradient?: string;
  containerGradient?: string;
  borderClassName?: string;
  containerClassName?: string;
}

const CardInfo: React.FC<CardInfoProps> = ({
  children,
  className = "",
  gradientBorder = false,
  borderGradient = "",
  containerGradient = "",
  borderClassName = "",
}) => {
  if (gradientBorder) {
    return (
      <div
        className={cn(
          "relative p-[1px] rounded-[18px]",
          borderClassName
        )}
        style={{
          background: borderGradient,
        }}
      >
        <div
          className={cn("rounded-[17px]", className)}
          style={{
            background: containerGradient,
          }}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "bg-(--background-secondary)",
        "rounded-[18px]",
        "border-1",
        "border-(--gray-7)",
        className
      )}
    >
      {children}
    </div>
  );
};

export default CardInfo;
